import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpContext, HttpContextToken, HttpParams, HttpResponse } from "@angular/common/http";
import {BehaviorSubject, Observable, Subject} from "rxjs";
import {filter, tap} from "rxjs/operators";
import {PaginatorAdapter} from "../../../shared/tables/paginator/paginator";
import {NO_FAIL} from "../../../utilities/http";

import type {ClickStatus, Notification} from '../notification.model';

@Injectable({providedIn: 'root'})
export class NotificationService {
  private http = inject(HttpClient);

  readonly basePath = '/notifications';

  unread: BehaviorSubject<number> = new BehaviorSubject(0);
  closeOnNavigate = new Subject<void>();
  panelOpened: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {
    //send view message
    this.panelOpened.pipe(filter(opened => opened)).subscribe(() => {
      this.updateClickStatus().subscribe();
      this.unread.next(0);
      //this.notificationService.getUnreadCount();
    });
  }

  getNotificationPaginatorAdapter(): PaginatorAdapter<Notification []> {
    return new PaginatorAdapter(this.http);
  }

  getNotifications(clickStatus?: ClickStatus, nextUrl?: string): Observable<HttpResponse<any>> {
    let params = new HttpParams({fromObject: {
        sort: '_id,desc',
        size: '20'
      }});
    if(clickStatus)
      params = params.set('clickStatus', clickStatus);

    return this.http.get<HttpResponse<Notification []>>(nextUrl ? nextUrl : this.basePath, {params: params, observe: 'response'});
  }

  getUnreadCount(clickStatus: ClickStatus = 'IDLE'): Observable<{count: number}> {
    const params = new HttpParams().set('clickStatus', clickStatus);
    const context = new HttpContext().set(NO_FAIL, true);
    return this.http.get<{count: number}>(this.basePath + '/unread-count', {params: params, context: context}).pipe(tap(val => this.unread.next(val.count)));
  }

  updateClickStatus(ctId?: string, clickStatus: ClickStatus = 'VIEWED'): Observable<any> {
    let params = new HttpParams().set('clickStatus', clickStatus);
    if(ctId) params = params.set('ctId', ctId);
    return this.http.get(this.basePath + '/update-click-status', {params: params});
  }

}
